var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAnswer = function SvgAnswer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_40088",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 40088",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80.201 91.399"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_25374",
    "data-name": "\\u30D1\\u30B9 25374",
    d: "M0,0H4.951V4.951H0Z",
    transform: "translate(4.951 41.231) rotate(180)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_25375",
    "data-name": "\\u30D1\\u30B9 25375",
    d: "M67.824,0H12.376A12.39,12.39,0,0,0,0,12.377V67.5A12.39,12.39,0,0,0,12.376,79.872h16.2L40.1,91.4,51.628,79.872h16.2A12.391,12.391,0,0,0,80.2,67.5V60.069H75.25V67.5a7.435,7.435,0,0,1-7.426,7.426H49.577L40.1,84.4l-9.477-9.477H12.376A7.434,7.434,0,0,1,4.951,67.5V12.377a7.434,7.434,0,0,1,7.426-7.426H67.824a7.435,7.435,0,0,1,7.426,7.426v32.84H80.2V12.377A12.391,12.391,0,0,0,67.824,0Z",
    transform: "translate(80.201 91.399) rotate(180)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_25377",
    "data-name": "\\u30D1\\u30B9 25377",
    d: "M459.5,202.5h4.951v4.951H459.5Z",
    transform: "translate(-396.626 -168.009)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_25378",
    "data-name": "\\u30D1\\u30B9 25378",
    d: "M459.5,172.5h4.951v4.951H459.5Z",
    transform: "translate(-396.626 -147.911)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_25380",
    "data-name": "\\u30D1\\u30B9 25380",
    d: "M343.138,236.408l4.627,1.762,3.22-8.455h15.591l3.189,8.451,4.632-1.748-13.2-34.982-4.739,0Zm21.569-11.643H352.87l5.946-15.611Z",
    transform: "translate(-318.669 -167.297)"
  })));
};
export default SvgAnswer;